import { render, staticRenderFns } from "./CustomerLedger.vue?vue&type=template&id=6f23cc41&scoped=true"
import script from "./CustomerLedger.vue?vue&type=script&lang=js"
export * from "./CustomerLedger.vue?vue&type=script&lang=js"
import style0 from "./CustomerLedger.vue?vue&type=style&index=0&id=6f23cc41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f23cc41",
  null
  
)

export default component.exports